import { SVGProps } from 'react';

export default function ChevronUp(props: SVGProps<SVGSVGElement>) {
  const { height = 12, width = 12, stroke = '#545454', ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M9.95906 7.52531L6.69906 4.26531C6.31406 3.88031 5.68406 3.88031 5.29906 4.26531L2.03906 7.52531'
        stroke={stroke}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
